import { useState } from "react";
import PropTypes from "prop-types";
import Button from "@/components/common/Button";
import WebIcon from "@/components/common/Web_Icons";

const SupportChatInput = ({ disabled, sending, onSend }) => {
  const [message, setMessage] = useState("");

  const handleSend = async () => {
    if (!message.trim() || disabled || sending) return;

    const text = message.trim();
    setMessage("");
    await onSend(text);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="p-0 mt-auto">
      <div className="flex items-center gap-2 p-3 rounded-lg bg-secondary">
        <input
          type="text"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={disabled ? "This ticket is closed" : "Type your message..."}
          className="flex-1 bg-transparent outline-none text-regular"
          disabled={disabled || sending}
        />
        <Button
          icon={<WebIcon icon="Send2" className="w-5 h-5" />}
          className="!p-2 !bg-transparent hover:!bg-gray-200"
          onClick={handleSend}
          disabled={disabled || sending || !message.trim()}
        />
      </div>
    </div>
  );
};

SupportChatInput.propTypes = {
  disabled: PropTypes.bool,
  sending: PropTypes.bool,
  onSend: PropTypes.func.isRequired,
};

export default SupportChatInput;
